import React from "react";
import { CharacterSheet, Equipamento, Item } from "../data/characterSchema";

interface Props {
  character: CharacterSheet;
  onChange: (character: CharacterSheet) => void;
}

export const EquipamentosInventario: React.FC<Props> = ({ character, onChange }) => {
  const addEquipamento = () => {
    onChange({
      ...character,
      equipamentos: [...character.equipamentos, { nome: "", tipo: "", nivel: 1, efeitos: "" }],
    });
  };

  const removeEquipamento = (index: number) => {
    onChange({
      ...character,
      equipamentos: character.equipamentos.filter((_, i) => i !== index),
    });
  };

  const updateEquipamento = (index: number, field: keyof Equipamento, value: any) => {
    const newEquipamentos = [...character.equipamentos];
    newEquipamentos[index] = { ...newEquipamentos[index], [field]: value };
    onChange({ ...character, equipamentos: newEquipamentos });
  };

  const addItem = () => {
    onChange({
      ...character,
      inventario: [...character.inventario, { nome: "", tipo: "", quantidade: 1, efeitos: "" }],
    });
  };

  const removeItem = (index: number) => {
    onChange({
      ...character,
      inventario: character.inventario.filter((_, i) => i !== index),
    });
  };

  const updateItem = (index: number, field: keyof Item, value: any) => {
    const newInventario = [...character.inventario];
    newInventario[index] = { ...newInventario[index], [field]: value };
    onChange({ ...character, inventario: newInventario });
  };

  return (
    <div className="section">
      <h2>Equipamentos e Inventário</h2>
      <div className="equipamentos-grid">
        <div>
          <h3>Equipamentos</h3>
          <button type="button" onClick={addEquipamento} className="btn-add">
            + Adicionar Equipamento
          </button>
          {character.equipamentos.length > 0 && (
            <table>
              <thead>
                <tr>
                  <th>Equipamento</th>
                  <th>Tipo</th>
                  <th>Nível</th>
                  <th>Efeitos</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {character.equipamentos.map((equipamento, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="text"
                        value={equipamento.nome}
                        onChange={(e) => updateEquipamento(index, "nome", e.target.value)}
                        placeholder="Nome"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={equipamento.tipo}
                        onChange={(e) => updateEquipamento(index, "tipo", e.target.value)}
                        placeholder="Tipo"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={equipamento.nivel}
                        onChange={(e) => updateEquipamento(index, "nivel", parseInt(e.target.value) || 1)}
                        min="1"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={equipamento.efeitos}
                        onChange={(e) => updateEquipamento(index, "efeitos", e.target.value)}
                        placeholder="Efeitos"
                      />
                    </td>
                    <td>
                      <button type="button" onClick={() => removeEquipamento(index)} className="btn-remove">
                        Remover
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div>
          <h3>Inventário</h3>
          <button type="button" onClick={addItem} className="btn-add">
            + Adicionar Item
          </button>
          {character.inventario.length > 0 && (
            <table>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Tipo</th>
                  <th>Quantidade</th>
                  <th>Efeitos</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {character.inventario.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="text"
                        value={item.nome}
                        onChange={(e) => updateItem(index, "nome", e.target.value)}
                        placeholder="Nome"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={item.tipo}
                        onChange={(e) => updateItem(index, "tipo", e.target.value)}
                        placeholder="Tipo"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={item.quantidade}
                        onChange={(e) => updateItem(index, "quantidade", parseInt(e.target.value) || 1)}
                        min="1"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={item.efeitos}
                        onChange={(e) => updateItem(index, "efeitos", e.target.value)}
                        placeholder="Efeitos"
                      />
                    </td>
                    <td>
                      <button type="button" onClick={() => removeItem(index)} className="btn-remove">
                        Remover
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};
